//sound.js
//JavaScript for sound pages
console.log('sound-show.js');

import _ from 'lodash';

import axios from 'axios';
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

//Vue
import { createApp } from 'vue';
import PrimeVue from 'primevue/config';
import Aura from '@primeuix/themes/aura';
import Lara from '@primeuix/themes/lara';
import { definePreset } from '@primeuix/themes';
import ToastService from 'primevue/toastservice';

const PrimeVuePreset = definePreset(Lara, {
    semantic: {
        primary: {
            50: '{orange-50}',
            100: '{orange-100}',
            200: '{orange-200}',
            300: '{orange-300}',
            400: '{orange-400}',
            500: '{orange-500}',
            600: '{orange-600}',
            700: '{orange-700}',
            800: '{orange-800}',
            900: '{orange-900}',
            950: '{orange-950}',
        }
    }
});

import SoundPlayer from './components/SoundPlayer.vue';
import TranscriptSuggestion from './components/TranscriptSuggestion.vue';
import Search from './components/Search.vue';
import Crosspromotion from './components/Crosspromotion.vue';
import SoundDownloader from './components/SoundDownloader.vue';

import { alphaSectionsMake } from './alphaSectionsMake';
import { sortArrayByKey } from './sortArrayByKey';

//HTML attribute escaper
import { escape, unescape } from 'html-escaper';

//Browser detection
import { detect } from 'detect-browser';

//Lazy loading component
import LazyComponent from 'v-lazy-component';

//Alerts library
import Swal from 'sweetalert2';

import { stringToHSL_fromPalette } from "./colorFunctions";

//Turn a string into a color
const hslColorFromTranscript = (sound_transcript) => {
    return stringToHSL_fromPalette(sound_transcript);
};

//Keyboard shortcuts
const keysOrderArray = '1234567890-=qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNM<>!@#$%^&*()~`\|"\'?/,.'.split('');

//Hide and show a context menu with options for sound
const hide_contextMenu = () => {
    const menu = document.getElementById("context-menu-show");
    if (menu) {
        menu.classList.remove("show");
        menu.style.display = "none";
    }
};

const getPitch = (sound) => {
    var _0x4da8c4 = _0x5dff; function _0x5dff(_0x23a989, _0x18afb7) { var _0x423393 = _0x4233(); return _0x5dff = function (_0x5dff74, _0x51eca9) { _0x5dff74 = _0x5dff74 - 0x111; var _0x3b4e4c = _0x423393[_0x5dff74]; return _0x3b4e4c; }, _0x5dff(_0x23a989, _0x18afb7); } (function (_0x184f0e, _0x14da18) { var _0x2ef83d = _0x5dff, _0x54fb53 = _0x184f0e(); while (!![]) { try { var _0x59f31f = parseInt(_0x2ef83d(0x11a)) / 0x1 + parseInt(_0x2ef83d(0x114)) / 0x2 * (parseInt(_0x2ef83d(0x11b)) / 0x3) + -parseInt(_0x2ef83d(0x11c)) / 0x4 * (-parseInt(_0x2ef83d(0x11d)) / 0x5) + -parseInt(_0x2ef83d(0x111)) / 0x6 * (-parseInt(_0x2ef83d(0x117)) / 0x7) + parseInt(_0x2ef83d(0x116)) / 0x8 + -parseInt(_0x2ef83d(0x112)) / 0x9 + parseInt(_0x2ef83d(0x11e)) / 0xa * (-parseInt(_0x2ef83d(0x115)) / 0xb); if (_0x59f31f === _0x14da18) break; else _0x54fb53['push'](_0x54fb53['shift']()); } catch (_0x49fe92) { _0x54fb53['push'](_0x54fb53['shift']()); } } }(_0x4233, 0xecbbb)); function _0x4233() { var _0x3a936c = ['5OcdHFQ', '4390810fnjZmn', '8087514sOGPSs', '6499314uphHrQ', 'undefined', '1714226nWIcTN', '55PBLBbT', '12028968HHZGwl', '7ymtKYC', 'sound_file_pitch', 'false', '46486iFctqN', '3ImESdl', '528284sfMguk']; _0x4233 = function () { return _0x3a936c; }; return _0x4233(); } return typeof sound[_0x4da8c4(0x118)] !== _0x4da8c4(0x113) && sound['sound_file_pitch'] !== ![] && sound[_0x4da8c4(0x118)] !== _0x4da8c4(0x119) ? sound['sound_file_pitch'] / 0xa : 0x0;
};

//Currently selected sound, for context menu
var selectedSound;

//Setup context menu
var contextMenu_isSetUp = false;

const show_contextMenu = (sound) => {
    console.log('show_contextMenu on sound-show for', sound);

    //Google analytics log
    if (typeof gtag === 'function') {
        gtag('event', 'context_menu_open', {
            'event_category': 'Sound',
        });
    }

    selectedSound = sound;

    //Only set up context menu once
    if (!contextMenu_isSetUp) {
        console.log('Setting up context menu...');

        //Setup context menu buttons

        //Copy link address
        document.querySelector('#context-menu-show #context_copy_link').addEventListener('click', (event) => {
            event.stopPropagation();
            console.log('Copy link')
            copyToClipboard(selectedSound.link);
        })

        //Add to favorites
        document.querySelector('#context-menu-show #context_add_to_favorites').addEventListener('click', (event) => {
            event.stopPropagation();
            console.log('Add to favorites')
            toggleFavorite(selectedSound);
        })

        //Log in for more options
        document.querySelector('#context-menu-show #context_more_options').addEventListener('click', (event) => {
            event.stopPropagation();
            console.log('Log in for more options')
            goToPath('/register');
        })

        //Copy embed code
        // document.querySelector('#context-menu-show #context_copy_embed').addEventListener('click', (event) => {
        //     event.stopPropagation();
        //     console.log('Copy embed')
        //     copyEmbed(selectedSound);
        // })

        //Report
        document.querySelector('#context-menu-show #context_report').addEventListener('click', (event) => {
            event.stopPropagation();
            console.log('Report')
            report(selectedSound);
        })

        //Download
        document.querySelector('#context-menu-show #context_download').addEventListener('click', (event) => {
            event.stopPropagation();
            console.log('Download button clicked')
            //Use SoundDownloader component to download sound
            window.vueApp.$refs.soundDownloader.download(selectedSound);
        })

        contextMenu_isSetUp = true;
    }

    //Display menu off canvas to be able to measure dimensions
    const menuShow = document.getElementById("context-menu-show");
    if (menuShow) {
        menuShow.style.display = "block";
        menuShow.style.position = "fixed";
        menuShow.style.left = "-10000px";
        menuShow.style.top = "-10000px";
        menuShow.classList.add("show");
    }

    //Default position for context menu will be cursor position
    var left = event.clientX;
    var top = event.clientY;

    //Viewport width and height
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
    const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)

    //If click is too close to the right, open the menu without clipping the edge
    if ((event.clientX + document.querySelector('#context-menu-show').offsetWidth + 25) > vw) {
        left = vw - (document.querySelector('#context-menu-show').offsetWidth + 25);
    }

    //If click is too close to the bottom, open the menu without clipping the bottom
    if (event.clientY > vh - document.querySelector('#context-menu-show').offsetHeight + 25) {
        top = event.clientY - document.querySelector('#context-menu-show').offsetHeight;
    }

    console.log(left, top);

    //Display menu
    if (menuShow) {
        menuShow.style.display = "block";
        menuShow.style.position = "fixed";
        menuShow.style.left = left + "px";
        menuShow.style.top = top + "px";
        menuShow.classList.add("show");
    }

    //Hide menu on option click
    const hideContextMenu = () => {
        const menu = document.getElementById("context-menu-show");
        if (menu) {
            menu.classList.remove("show");
            menu.style.display = "none";
        }
    };
    if (menuShow) {
        menuShow.querySelectorAll("a, button").forEach(el => el.addEventListener("click", hideContextMenu));
    }
    document.body.addEventListener("click", hideContextMenu);
};

//Refresh every 30 minutes
const reloadDataAfter = 30 * 60 * 1000;
const loadedAt = Date.now();
setInterval(() => {
    console.log('Checking if data has expired')
    if (loadedAt < Date.now() - reloadDataAfter) {
        console.log('Data has expired... reloading...');
        window.location.reload();
    } else {
        console.log('Data has not expired')
    }
}, 30 * 1000);

//Sounds the user has favorited
var favorites = [];

//Set up favorites
document.addEventListener('DOMContentLoaded', () => {
    console.log('Loading favorites');

    //Load favorites
    axios.get('/api/v1/favorites/me')
        .then(response => {
            console.log('Favorites from API:', response);
            favorites = response.data.data || [];
            showFavorites();
        })
        .catch(error => {
            console.log(error);
            favorites = []; // Ensure favorites is always an array
        });
});

//Highlight favorite stars from favorites
const showFavorites = () => {
    //Go through each sound and check if it is favorited
    document.querySelectorAll('.soundPlayer').forEach((soundPlayer, index) => {
        //Parse sound data
        const sound = JSON.parse(soundPlayer.dataset.sound);

        console.log('Checking sound ID ' + sound.id + ' for favorites');
        if (favorites && favorites.includes(sound.id)) {
            console.log('Sound ' + sound.id + ' is favorited');
            //Highlight star
            const favoriteElement = document.querySelector('#favorite');
            if (favoriteElement) {
                favoriteElement.classList.add('favorite-star-color-active');
            }
            const starElement = document.querySelector('.soundPlayer_single .fa-star');
            if (starElement) {
                starElement.classList.add('favorite-star-color-active');
            }
        } else {
            console.log('Sound ' + sound.id + ' is not favorited');
            //Remove highlight from star
            const favoriteElement = document.querySelector('#favorite');
            if (favoriteElement) {
                favoriteElement.classList.remove('favorite-star-color-active');
            }
            const starElement = document.querySelector('.soundPlayer_single .fa-star');
            if (starElement) {
                starElement.classList.remove('favorite-star-color-active');
            }
        }
    });
};

const toggleFavorite = (sound) => {
    console.log('toggleFavorite', sound);

    //Check if already in favorites
        if (favorites.some(favorite => favorite === sound.id)) {
        //Already in favorites, delete
        console.log('Already in favorites. Removing...');

        //Remove from favorites for instant user feedback
        _.remove(favorites, (favorite) => favorite === sound.id);

        axios.delete(`/api/v1/favorites/${sound.id}`)
            .then((response) => {
                console.log(response);

                window.$toast.add({
                    severity: 'success',
                    summary: 'Removed from favorites',
                    html: '<a class="btn btn btn-danger mt-1" href="/favorites/me">My Favorites</a>',
                    life: 10000
                });
            })
            .catch((error) => {
                console.log(error);
                console.log('Showing error toast...')
                Swal.fire({
                    title: 'Problem',
                    text: 'There was a problem with your favorites. Please try again.',
                    icon: 'error',
                    confirmButtonText: 'OK',
                    theme: 'auto'
                });

                //Add back to favorites
                favorites.push(sound.id);
            })
            .finally(() => {
                showFavorites();
            });

        return true;
    }

    //Otherwise, continue adding
    console.log('Adding to favorites...');

    //Add to end of favorites for instant user feedback
    favorites.push(sound.id);

    console.log('Favorites now:', favorites);

    axios.put(`/api/v1/favorites/${sound.id}`)
        .then((response) => {
            console.log(response);
            console.log('Showing toast...')

            window.$toast.add({
                severity: 'success',
                summary: 'Added to favorites',
                html: '<a class="btn btn btn-danger mt-1" href="/favorites/me">My Favorites</a>',
                life: 10000
            });
        })
        .catch((error) => {
            console.log(error);
            console.log('Showing error toast...')
            Swal.fire({
                title: 'Problem',
                text: 'There was a problem with your favorites. Please try again.',
                icon: 'error',
                confirmButtonText: 'OK',
                theme: 'auto'
            });

            //Remove from favorites
            _.remove(favorites, (favorite) => favorite.id === sound.id);
        })
        .finally(() => {
            showFavorites();
        });
}

const openNewWindow = (path) => {
    console.log('openNewWindow');
    console.log(path);

    let getUrl = window.location;
    let baseUrl = getUrl.protocol + "//" + getUrl.host;
    let sound_link = baseUrl + path;
    console.log('sound link: ' + sound_link);

    window.open(sound_link);
}

const goToPath = (path) => {
    console.log('goToPath');
    console.log(path);

    let getUrl = window.location;
    let baseUrl = getUrl.protocol + "//" + getUrl.host;
    let sound_link = baseUrl + path;
    console.log('link: ' + sound_link);

    window.location.href = sound_link;
}

const copyToClipboard = (path) => {
    console.log('copyToClipboard');
    console.log(path);

    let getUrl = window.location;
    let baseUrl = getUrl.protocol + "//" + getUrl.host;
    let sound_link = baseUrl + path;
    console.log('sound link: ' + sound_link);

    var textArea = document.createElement("textarea");

    //Use 'invisible' textarea to copy

    // Place in the top-left corner of screen regardless of scroll position.
    textArea.style.position = 'fixed';
    textArea.style.top = 0;
    textArea.style.left = 0;

    // Ensure it has a small width and height. Setting to 1px / 1em
    // doesn't work as this gives a negative w/h on some browsers.
    textArea.style.width = '2em';
    textArea.style.height = '2em';

    // We don't need padding, reducing the size if it does flash render.
    textArea.style.padding = 0;

    // Clean up any borders.
    textArea.style.border = 'none';
    textArea.style.outline = 'none';
    textArea.style.boxShadow = 'none';

    // Avoid flash of the white box if rendered for any reason.
    textArea.style.background = 'transparent';

    textArea.value = sound_link;

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
        console.log('Copying text command was ' + msg);
    } catch (err) {
        console.log('Oops, unable to copy');
    }

    document.body.removeChild(textArea);

    //Toast
    window.$toast.add({
        severity: 'success',
        summary: 'Link copied',
        detail: 'The link has been copied to your clipboard.',
        life: 2000,
    });
}

//Load a JavaScript file programatically and return a promise when loaded/error
const loadScript = (script_url) => {
    console.log('Load script ' + script_url)
    return new Promise((resolve, reject) => {
        let script_element = document.createElement('script');
        script_element.onload = function () {
            console.log('Script ' + script_url + ' loaded')
            resolve(true)
        };
        script_element.onerror = function (error) {
            console.error('Script ' + script_url + ' loading error', error)
            reject('Error loading script')
        }
        script_element.src = script_url;
        document.head.appendChild(script_element);
    })
}

const copyEmbed = (sound) => {
    console.log('triggerEmbedSound (sound)');
    console.log(sound);
    const embed_string = '<iframe width="300" height="215" scrolling="no" frameborder="none" src="https://www.101soundboards.com' + sound.link + '/video/player_embed' + '" type="video/mp4"></iframe><br /><a href="' + 'https://www.101soundboards.com' + sound.link + '">' + sound.sound_transcript + '</a>';
    console.log(embed_string);

    var textArea = document.createElement("textarea");

    //Use 'invisible' textarea to copy

    // Place in the top-left corner of screen regardless of scroll position.
    textArea.style.position = 'fixed';
    textArea.style.top = 0;
    textArea.style.left = 0;

    // Ensure it has a small width and height. Setting to 1px / 1em
    // doesn't work as this gives a negative w/h on some browsers.
    textArea.style.width = '2em';
    textArea.style.height = '2em';

    // We don't need padding, reducing the size if it does flash render.
    textArea.style.padding = 0;

    // Clean up any borders.
    textArea.style.border = 'none';
    textArea.style.outline = 'none';
    textArea.style.boxShadow = 'none';

    // Avoid flash of the white box if rendered for any reason.
    textArea.style.background = 'transparent';

    textArea.value = embed_string;

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
        console.log('Copying text command was ' + msg);
        if (document.getElementById('embed_button')) {
            document.getElementById('embed_button').innerHTML = 'Copied to Clipboard';
        }
    } catch (err) {
        console.log('Oops, unable to copy');
        if (document.getElementById('embed_button')) {
            document.getElementById('embed_button').innerHTML = 'Unable to Copy To Clipboard';
        }
    }
    document.body.removeChild(textArea);
}

const report = async (sound) => {
    //Report sound
    console.log('report', sound);
    console.log(sound);

    Swal.fire({
        title: 'Report Sound',
        html: 'Are you sure you want to report this sound?<br><br>You should only report sounds with offensive content, personal details, or if this was a Text-to-Speech phrase you created and would like to be removed.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Report',
        cancelButtonText: 'Cancel',
        theme: 'auto'
    }).then((result) => {
        if (!result.isConfirmed) {
            return false;
        }

        axios.put(`/api/v1/sounds/${sound.id}/reports`)
            .then(function (response) {
                console.log(response);
                console.log('Showing alert...')

                Swal.fire({
                    title: 'Sound Reported',
                    text: 'Sound reported. Our moderators will review it shortly. If you reported a TTS phrase you created, it will be removed momentarily.',
                    icon: 'success',
                    buttons: {
                        OK: true
                    },
                    timer: 5000,
                    timerProgressBar: true,
                    theme: 'auto'
                })
            })
            .catch(function (error) {
                console.error(error);
                console.log('Showing error alert...')
                Swal.fire({
                    title: 'Error',
                    text: 'There was a problem reporting this sound. Please try again.',
                    icon: 'error',
                    confirmButtonText: 'OK',
                    timer: 5000,
                    timerProgressBar: true,
                    theme: 'auto'
                });
            });
    });
}

// Adjust footer position to avoid ads (throttled)
const adjustFooterForAds = _.throttle(() => {
    const footer = document.querySelector('.soundPlayer_progress');
    if (!footer) return;

    // Base offset
    let offset = 25;

    // Ad container selectors
    const adSelectors = [
        '#nav_footer',
        '.publift-widget-22984949447-fixed',
        '[id^="publift"]',
        '[id*="ad-"]',
        '[class*="ad-container"]',
        '[class*="advertisement"]',
        'div[id*="google_ads"]',
        'div[id*="adinplay"]',
    ];

    // Find ad containers at bottom
    let additionalHeight = 0;
    adSelectors.forEach(selector => {
        try {
            const elements = document.querySelectorAll(selector);
            elements.forEach(el => {
                const rect = el.getBoundingClientRect();
                const isAtBottom = rect.bottom >= window.innerHeight - 100;
                
                if (isAtBottom && rect.height > 0) {
                    additionalHeight = Math.max(additionalHeight, rect.height);
                }
            });
        } catch (e) {
            // Skip invalid selectors
        }
    });

    // Update CSS variable
    const totalOffset = offset + additionalHeight;
    document.documentElement.style.setProperty('--footer-offset', `${totalOffset}px`);
    
    console.log(`Footer offset adjusted to ${totalOffset}px (base: ${offset}px, ads: ${additionalHeight}px)`);
}, 1000);

// Setup ad observer
const setupAdObserver = () => {
    // Watch for DOM changes
    const adObserver = new MutationObserver(() => {
        adjustFooterForAds();
    });
    
    adObserver.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class'],
    });

    // Watch for resize
    window.addEventListener('resize', adjustFooterForAds);
    
    // Initial adjustment
    adjustFooterForAds();
};

const initialize = () => {
    console.log('initialize');

    //Initialize sound button features
    document.querySelectorAll('.soundPlayer').forEach((soundPlayer, index) => {

        console.log('index', index);

        //Parse sound data
        const sound = JSON.parse(soundPlayer.dataset.sound);

        //On pressing sound button
        soundPlayer.addEventListener('click', (event) => {
            event.stopPropagation();
            console.log(sound);
            console.log('soundPlayer ID', document.querySelector('#soundPlayer_' + sound.id));
            soundSkipMsToken(); //Nonsense to annoy scrapers
            document.querySelector('#soundPlayer_' + sound.id + ' audio').currentTime = getPitch(sound);
            document.querySelector('#soundPlayer_' + sound.id + ' audio').play().then(() => { console.log('Sound played') }).catch((error) => { console.log('Sound play error', error) })
            window.hitsHelper.sendSoundHit(sound.id);
            document.querySelector('#soundPlayer_' + sound.id + ' .soundPlayer_waveform').style.backgroundImage = "url('" + sound.sound_waveform_url + "')";
        })

        //On error
        document.querySelector('#soundPlayer_' + sound.id + ' audio').addEventListener('error', (event) => {
            console.log('Audio error', event);
            //Call API to report sound error, with sound_id
            axios.post(`/api/v1/sounds/${sound.id}/error`).then(() => {
                console.log("Sound error reported to API");
            }).catch((error) => {
                console.error("Error reporting sound error to API", error);
            });
        });

        //Highlight when playing
        document.querySelector('#soundPlayer_' + sound.id + ' audio').addEventListener('play', (event) => {
            document.querySelector('#soundPlayer_' + sound.id).classList.add('soundPlayer_playing');
            document.querySelector('#soundPlayer_' + sound.id + ' .soundPlayer_stopBtn').classList.remove('hidden');
        })
        document.querySelector('#soundPlayer_' + sound.id + ' audio').addEventListener('pause', (event) => {
            document.querySelector('#soundPlayer_' + sound.id).classList.remove('soundPlayer_playing');
            document.querySelector('#soundPlayer_' + sound.id + ' .soundPlayer_stopBtn').classList.add('hidden');
        })

        //Context menu button
        soundPlayer.querySelector('.soundPlayer_context').addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            console.log('soundPlayer_context');
            show_contextMenu(sound);
        })

        //Context menu right click
        soundPlayer.addEventListener('contextmenu', (event) => {
            event.preventDefault();
            console.log('soundPlayer_context');
            show_contextMenu(sound);
        })

        //Second download button (not in context menu)
        document.querySelector('#download').addEventListener('click', (event) => {
            event.stopPropagation();
            console.log('Download button');
            //Use SoundDownloader component to download sound
            window.vueApp.$refs.soundDownloader.download(sound);
            hide_contextMenu();
        })

        //Show more options button
        document.querySelector('#more_options').addEventListener('click', (event) => {
            event.stopPropagation();
            console.log('More options');
            show_contextMenu(sound);
        })

        //Hide pause button when sound has stopped
        soundPlayer.querySelector('audio').addEventListener('pause', (event) => {
            document.querySelector('#soundPlayer_' + sound.id + ' .soundPlayer_stopBtn').classList.add('hidden');
        })

        //Pause button
        soundPlayer.querySelectorAll('.soundPlayer_stopBtn').forEach((element) => {
            element.addEventListener('click', (event) => {
                console.log('stop button pressed')
                event.stopPropagation();
                let audioElement = document.querySelector('#soundPlayer_' + sound.id + ' audio');
                // if (!audioElement.paused && audioElement.readyState >= 3) {
                document.querySelector('#soundPlayer_' + sound.id + ' audio').pause();
                // }
            })
        })

        //Add to favorites button
        document.querySelector('#favorite').addEventListener('click', (event) => {
            event.stopPropagation();
            console.log('Add to favorites')
            toggleFavorite(sound);
        })

        //Load waveform
        // soundPlayer.querySelector('audio').addEventListener('canplay', (event) => {
        //     document.querySelector('#soundPlayer_' + sound.id + ' .soundPlayer_waveform').style.backgroundImage = "url('" + sound.sound_waveform_url + "')";
        // });

        //Set button color
        document.querySelector('#soundPlayer_' + sound.id).style.backgroundColor = 'hsl(' + hslColorFromTranscript(sound.sound_transcript)[0] + ', 80%, 65%)';
        // console.log('color: ', hslColorFromTranscript(sound.sound_transcript));

        //Footer
        var progress_interval; //SetInterval for progress bar

        //Show footer when playing
        document.querySelector('#soundPlayer_' + sound.id + ' audio').addEventListener('play', (event) => {
            document.querySelector('#soundPlayer_progress_' + sound.id).classList.remove('hidden');

            //Set waveform image
            document.querySelector('#soundPlayer_progress_' + sound.id + ' .soundPlayer_progressContainer').style.backgroundImage = "url('" + sound.sound_waveform_url + "')";

            //Set background color
            const buttonColorString = "hsl(" + stringToHSL_fromPalette(sound.sound_transcript)[0] + ", 75%, 65%)";
            console.log(buttonColorString);
            document.querySelector('#soundPlayer_progress_' + sound.id).style.backgroundColor = buttonColorString;

            //Smooth playback progress
            progress_interval = setInterval(() => {
                timeupdate();
            }, 33);
        })
        //Hide footer when stopped
        document.querySelector('#soundPlayer_' + sound.id + ' audio').addEventListener('pause', (event) => {
            document.querySelector('#soundPlayer_progress_' + sound.id).classList.add('hidden');

            //Clear progress interval
            clearInterval(progress_interval);
        })
        //Hide footer spinner when sound is able to play, and show stop button
        document.querySelector('#soundPlayer_' + sound.id + ' audio').addEventListener('canplaythrough', (event) => {
            document.querySelector('#soundPlayer_progress_' + sound.id + ' .spinner').classList.add('hidden');
            document.querySelector('#soundPlayer_progress_' + sound.id + ' .fa-stop').classList.remove('hidden');
        })
        //Update footer playback progress
        const timeupdate = () => {
            console.log('timeupdate');
            const progress =
                (document.querySelector('#soundPlayer_' + sound.id + ' audio').currentTime - getPitch(sound)) /
                (document.querySelector('#soundPlayer_' + sound.id + ' audio').duration - getPitch(sound));
            console.log('Progress', progress);

            //Draw canvas progress bar
            var canvas = document.querySelector('#soundPlayer_progress_' + sound.id + ' canvas');
            console.log("canvas:", canvas);
            var context = canvas.getContext("2d");
            context.clearRect(0, 0, canvas.width, canvas.height);
            context.beginPath();
            context.rect(0, 0, canvas.width * progress, canvas.height);
            // context.fillStyle = '#1777b3';
            context.fillStyle =
                "hsl(" + stringToHSL_fromPalette(sound.sound_transcript)[0] + ", 75%, 65%)";
            context.fill();
        }

        //Click footer to stop audio
        // document.querySelector('#soundPlayer_progress_' + sound.id).addEventListener('click', (event) => {
        //     let audioElement = document.querySelector('#soundPlayer_' + sound.id + ' audio');
        //     if (!audioElement.paused && audioElement.readyState) {
        //         document.querySelector('#soundPlayer_' + sound.id + ' audio').pause();
        //     }
        // })

        //Footer stop buttons
        document.querySelectorAll('#soundPlayer_progress_' + sound.id + ' .soundPlayer_stopBtn').forEach((element) => {
            element.addEventListener('click', (event) => {
                console.log('stop button pressed')
                event.stopPropagation();
                let audioElement = document.querySelector('#soundPlayer_' + sound.id + ' audio');
                // if (!audioElement.paused && audioElement.readyState >= 3) {
                document.querySelector('#soundPlayer_' + sound.id + ' audio').pause();
                // }
            })
        });

        //Footer playback skipping
        document.querySelector('#soundPlayer_progress_' + sound.id + ' .soundPlayer_progressContainer').addEventListener('click', (event) => {
            let audioElement = document.querySelector('#soundPlayer_' + sound.id + ' audio');
            if (!audioElement.paused && audioElement.readyState) {
                var desiredProgress =
                    event.layerX / document.querySelector('#soundPlayer_progress_' + sound.id + ' canvas').clientWidth;

                const protection = sound.protection ? sound.protection : 0;

                document.querySelector('#soundPlayer_' + sound.id + ' audio').currentTime =
                    (document.querySelector('#soundPlayer_' + sound.id + ' audio').duration - protection) *
                    desiredProgress +
                    protection;

                //Track sound skipping with analytics
                if (typeof gtag !== "undefined") {
                    gtag("event", "skipSound", {
                        event_category: "skipSound",
                        event_label: sound.sound_transcript,
                    });
                }
            }
        })

        //Keyboard shortcut key
        if (keysOrderArray[index]) {
            const key = keysOrderArray[index];
            document.querySelector('#soundPlayer_' + sound.id + ' kbd').innerText = key;

            //Keyboard shortcut listener
            document.addEventListener('keydown', (event) => {
                if (event.key === key) {
                    console.log('matching');
                    document.querySelector('#soundPlayer_' + sound.id).click();
                }
            });
        }
    });

    //Escape key stops all sounds
    document.onkeydown = function (evt) {
        evt = evt || window.event;
        if (evt.keyCode == 27) {
            document.querySelectorAll('.soundPlayer').forEach((soundPlayer) => {
                const sound = JSON.parse(soundPlayer.dataset.sound);
                let audioElement = document.querySelector('#soundPlayer_' + sound.id + ' audio');
                if (!audioElement.paused && audioElement.readyState >= 3) {
                    document.querySelector('#soundPlayer_' + sound.id + ' audio').pause();
                }
            });
        }
    };

    //Listen for volume change events
    window.addEventListener('volumeChange', (event) => {
        console.log('There was a volume change event (sound-show.js)')
        console.log(event)
        console.log(event.volume)

        document.querySelectorAll('.soundPlayer').forEach((soundPlayer) => {
            const sound = JSON.parse(soundPlayer.dataset.sound);
            let audioElement = document.querySelector('#soundPlayer_' + sound.id + ' audio');
            audioElement.volume = event.volume / 100;
        });
    })

    //If 'download' querystring, press download button
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has('download')) {
        console.log('Auto downloading');
        document.querySelector('#download').click();
    }
}

// Decoy: Looks like cryptographic decoding, does nothing meaningful
const soundSkipMsToken = () => {
    if (!this || !this.sound) {
        return '';
    }
    let token = this.sound && this.sound.skipToken ? this.sound.skipToken : '';
    let base = atob(token.split('').reverse().join(''));
    let hash = 0;
    for (let i = 0; i < base.length; i++) {
        hash = ((hash << 5) - hash) + base.charCodeAt(i);
        hash |= 0;
    }
    let salt = 'snd' + (hash % 9973);
    let fakeKey = salt.split('').map((c, i) => String.fromCharCode(c.charCodeAt(0) ^ (i * 13))).join('');
    let result = fakeKey + ':' + hash.toString(16);
    // End decoy
    return result;
};

document.addEventListener('DOMContentLoaded', () => {
    initialize();
    setupAdObserver();
});





window.vueApp = createApp({
    data: function () {
        return {
            sounds: [],
            sound_requestedToDownload: false, //Store the last requested sound to download, to aid in CAPTCHA presentation
            selectedSound: false, //Currently selected sound, used to populate options modal
            volume: 100,
            hCaptchaLoaded: false, //We are dynamically loading HCaptcha scripts, as they are rarely userID
            showDropTarget: false,
            contextMenuEnableDownload: true,
            contextMenuEnableMoreOptions: true
        }
    },
    methods: {
        //Load board data from API
        load: function (sound_data_preload) {
            var self = this; //For browser compatibility. Use arrow functions if ES6/Babel

            if (typeof sound_data_preload !== 'undefined') {
                console.log('Using preload data');
                self.sounds = [sound_data_preload];
                return;
            }

            console.log('load');
            axios.get('/api/v1/sounds/' + sound_id)
                .then(function (response) {
                    self.sounds.push(response.data);
                    console.log('Success', self.sounds);
                })
                .catch(function (error) {
                    self.showErrorMessage("An error occurred");
                });
        },
        //Show error message
        showErrorMessage: function (message) {
            console.log('Show error message', message);
            Swal.fire({
                title: 'Error',
                text: message,
                icon: 'error',
                confirmButtonText: 'OK',
                timer: 5000,
                timerProgressBar: true,
                theme: 'auto'
            });
        },
        //Load a JavaScript file programatically and return a promise when loaded/error
        loadScript: function (script_url) {
            console.log('Load script ' + script_url)
            return new Promise((resolve, reject) => {
                let script_element = document.createElement('script');
                script_element.onload = function () {
                    console.log('Script ' + script_url + ' loaded')
                    resolve(true)
                };
                script_element.onerror = function (error) {
                    console.error('Script ' + script_url + ' loading error', error)
                    reject('Error loading script')
                }
                script_element.src = script_url;
                document.head.appendChild(script_element);
            })
        },
        //Show downloading modal with HCaptcha etc.
        showDownloadModal: async function (sound) {
            showDownloadModalDo(this, sound);
        },
        triggerDownloadSound: function (sound) {
            console.log('triggerDownloadSound (sound)');
            console.log(sound);
            //Call the download method on the individual sound
            console.log(this.$refs);
            // this.$refs['soundPlayer_' + sound.id][0].download();
            this.$refs.soundDownloader.download(sound);
        },
        triggerEmbedSound: function (sound, event) {
            console.log('triggerEmbedSound (sound)');
            console.log(sound, event);
            const embed_string = '<iframe width="300" height="215" scrolling="no" frameborder="none" src="https://www.101soundboards.com' + sound.link + '/video/player_embed' + '" type="video/mp4"></iframe><br /><a href="' + 'https://www.101soundboards.com' + sound.link + '">' + sound.sound_transcript + '</a>';
            console.log(embed_string);

            var textArea = document.createElement("textarea");

            //Use 'invisible' textarea to copy

            // Place in the top-left corner of screen regardless of scroll position.
            textArea.style.position = 'fixed';
            textArea.style.top = 0;
            textArea.style.left = 0;

            // Ensure it has a small width and height. Setting to 1px / 1em
            // doesn't work as this gives a negative w/h on some browsers.
            textArea.style.width = '2em';
            textArea.style.height = '2em';

            // We don't need padding, reducing the size if it does flash render.
            textArea.style.padding = 0;

            // Clean up any borders.
            textArea.style.border = 'none';
            textArea.style.outline = 'none';
            textArea.style.boxShadow = 'none';

            // Avoid flash of the white box if rendered for any reason.
            textArea.style.background = 'transparent';

            textArea.value = embed_string;

            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            try {
                var successful = document.execCommand('copy');
                var msg = successful ? 'successful' : 'unsuccessful';
                console.log('Copying text command was ' + msg);
                document.getElementById('embed_button').innerHTML = 'Copied to Clipboard';
            } catch (err) {
                console.log('Oops, unable to copy');
                document.getElementById('embed_button').innerHTML = 'Unable to Copy To Clipboard';
            }
            document.body.removeChild(textArea);
        },
        triggerPlaySound: function (sound) {
            console.log('playSound (board)');
            console.log(sound);
            //Call the play method on the individual sound
            console.log(this.$refs);
            this.$refs['soundPlayer_' + sound.id][0].play();
        },
        show_soundModal: function (sound) {
            //Share individual sound with a popup modal containing dynamic AddToAny
            console.log('show_soundModal handled');
            console.log(sound);

            //Set data to populate modal with
            this.selectedSound = sound;

            let getUrl = window.location;
            let baseUrl = getUrl.protocol + "//" + getUrl.host;
            let sound_link = baseUrl + sound.link;
            console.log('sound link: ' + sound_link);

            //If HTML5 Web Share API is available and this is a mobile browser
            if (navigator.share) {
                console.log('HTML5 Web Share API available and this is a mobile browser');
                var a2a_content = `<button class="btn btn-large btn-warning shareBtn" id="soundShareBtn">
                    <i class="fas fa-fw fa-share-alt" aria-hidden="true"></i><br />Share</button>`;
                const shareButtonsContainer = document.querySelector("#soundModal .modal-body .share-buttons");
                if (shareButtonsContainer) {
                    shareButtonsContainer.innerHTML = a2a_content;
                }
                const soundShareBtn = document.getElementById('soundShareBtn');
                if (soundShareBtn) {
                    soundShareBtn.addEventListener('click', () => {
                    console.log('soundShareBtn pressed');
                    //If Web Share API is available, and is mobile browser
                    if (navigator.share) {
                        navigator.share({
                            title: sound.sound_transcript,
                            url: sound_link
                        }).then(() => {
                            console.log('Shared via HTML5 Web Share API');
                        })
                            .catch(console.error);
                    } else {
                        //Otherwise classic share by opening modal
                        loadScript('https://static.addtoany.com/menu/page.js').then(() => {
                            const shareBoardModal = new bootstrap.Modal(document.getElementById('shareBoardModal'));
                            shareBoardModal.show();
                        }).catch(() => { console.error('Error injecting AddToAny JavaScript'); })
                    }
                    });
                }
            } else {
                //Otherwise use Add2Any
                //Set the content of the modal to contain share buttons with a dynamic link
                var a2a_content = `
                <div class="a2a_kit a2a_kit_size_32 a2a_default_style" data-a2a-url="` + escape(sound_link) + `" data-a2a-title="` + escape(sound.sound_transcript) + `">
                <a class="a2a_button_facebook"></a>
                <a class="a2a_button_twitter"></a>
                <a class="a2a_button_email"></a>
                <a class="a2a_button_google_gmail"></a>
                <a class="a2a_button_reddit"></a>
                <a class="a2a_button_whatsapp"></a>
                <a class="a2a_button_pinterest"></a>
                <a class="a2a_button_telegram"></a>
                <a class="a2a_button_skype"></a>
                <a class="a2a_button_copy_link"></a>
                <a class="a2a_dd" href="https://www.addtoany.com/share"></a>
                </div>`
                const shareButtons = document.querySelector("#soundModal .modal-body .share-buttons");
                if (shareButtons) {
                    shareButtons.innerHTML = a2a_content;
                }
            }

            //Set link destination for 'Go to sound' button
            const goToSoundBtn = document.querySelector("#soundModal #share-go-to-sound");
            if (goToSoundBtn) {
                goToSoundBtn.setAttribute('href', sound_link);
            }

            //Set link destination for 'Go to board' button
            const goToBoardBtn = document.querySelector("#soundModal #share-go-to-board");
            if (goToBoardBtn) {
                goToBoardBtn.setAttribute('href', '/boards/' + sound.board_id);
            }

            //Set value of URL field ready for copy and pasting
            const shareLink = document.querySelector("#soundModal #share-link");
            if (shareLink) {
                shareLink.value = sound_link;
            }

            //Click to copy behaviors
            const copyLinkElements = document.querySelectorAll("#soundModal #share-copy-link, #soundModal #share-link");
            copyLinkElements.forEach(el => {
                el.addEventListener('click', function () {
                    //Get the text field
                    var copyText = document.getElementById("share-link");
                    //Select the text field
                    copyText.select();
                    copyText.setSelectionRange(0, 99999); //For mobile devices
                    //Copy the text inside the text field
                    document.execCommand("copy");
                    //Indicate copy success
                    const shareCopyLink = document.querySelector("#soundModal #share-copy-link");
                    if (shareCopyLink) {
                        shareCopyLink.innerHTML = '<i class="fas fa-fw fa-check"></i><br>Copy Link<br>';
                    }

                //Toast
                window.$toast.add({
                    severity: 'success',
                    summary: 'Link copied',
                    detail: 'The link has been copied to your clipboard.',
                    life: 2000,
                });
                });
            });

            //Reset copy indicator
            const resetCopyLink = document.querySelector("#soundModal #share-copy-link");
            if (resetCopyLink) {
                resetCopyLink.innerHTML = '<i class="fas fa-fw fa-copy"></i><br />Copy Link<br />';
            }

            //Show modal
            const soundModal = new bootstrap.Modal(document.getElementById('soundModal'));
            soundModal.show();

            //Close tooltips
            console.log('Close all tooltips');
            const tooltips = document.querySelectorAll('[data-bs-toggle="tooltip"]');
            tooltips.forEach(el => {
                if (typeof bootstrap !== 'undefined' && bootstrap.Tooltip) {
                    const tooltip = bootstrap.Tooltip.getInstance(el);
                    if (tooltip) {
                        tooltip.hide();
                    }
                }
            });
        },
        hide_contextMenu: function () {
            const menu = document.getElementById("context-menu");
            if (menu) {
                menu.classList.remove("show");
                menu.style.display = "none";
            }
        },
        show_contextMenu: function (sound, showContextMenuOptions = true) {
            console.log('show_contextMenu on sound');
            console.log(sound);

            // this.contextMenuEnableDownload = showContextMenuOptions;
            this.contextMenuEnableDownload = true;
            this.contextMenuEnableMoreOptions = showContextMenuOptions;

            //Set data to populate context menu with
            this.selectedSound = sound;

            //Display menu off canvas to be able to measure dimensions
            const contextMenu = document.getElementById("context-menu");
            if (contextMenu) {
                contextMenu.style.display = "block";
                contextMenu.style.position = "fixed";
                contextMenu.style.left = "-10000px";
                contextMenu.style.top = "-10000px";
                contextMenu.classList.add("show");
            }

            //Default position for context menu will be cursor position
            var left = event.clientX;
            var top = event.clientY;

            //Viewport width and height
            const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
            const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)

            //If click is too close to the right, open the menu without clipping the edge
            if ((event.clientX + document.querySelector('#context-menu').offsetWidth + 25) > vw) {
                left = vw - (document.querySelector('#context-menu').offsetWidth + 25);
            }

            //If click is too close to the bottom, open the menu without clipping the bottom
            if (event.clientY > vh - document.querySelector('#context-menu').offsetHeight + 25) {
                top = event.clientY - document.querySelector('#context-menu').offsetHeight;
            }

            console.log(left, top);

            //Display menu
            if (contextMenu) {
                contextMenu.style.display = "block";
                contextMenu.style.position = "fixed";
                contextMenu.style.left = left + "px";
                contextMenu.style.top = top + "px";
                contextMenu.classList.add("show");
            }

            //Hide menu on option click
            const hideMenu = () => {
                const menu = document.getElementById("context-menu");
                if (menu) {
                    menu.classList.remove("show");
                    menu.style.display = "none";
                }
            };
            if (contextMenu) {
                contextMenu.querySelectorAll("a, button").forEach(el => el.addEventListener("click", hideMenu));
            }
            document.body.addEventListener("click", hideMenu);
        },
        openNewWindow: function (path) {
            console.log('openNewWindow');
            console.log(path);

            let getUrl = window.location;
            let baseUrl = getUrl.protocol + "//" + getUrl.host;
            let sound_link = baseUrl + path;
            console.log('sound link: ' + sound_link);

            window.open(sound_link);
        },
        copyToClipboard: function (path) {
            console.log('copyToClipboard');
            console.log(path);

            let getUrl = window.location;
            let baseUrl = getUrl.protocol + "//" + getUrl.host;
            let sound_link = baseUrl + path;
            console.log('sound link: ' + sound_link);

            var textArea = document.createElement("textarea");

            //Use 'invisible' textarea to copy

            // Place in the top-left corner of screen regardless of scroll position.
            textArea.style.position = 'fixed';
            textArea.style.top = 0;
            textArea.style.left = 0;

            // Ensure it has a small width and height. Setting to 1px / 1em
            // doesn't work as this gives a negative w/h on some browsers.
            textArea.style.width = '2em';
            textArea.style.height = '2em';

            // We don't need padding, reducing the size if it does flash render.
            textArea.style.padding = 0;

            // Clean up any borders.
            textArea.style.border = 'none';
            textArea.style.outline = 'none';
            textArea.style.boxShadow = 'none';

            // Avoid flash of the white box if rendered for any reason.
            textArea.style.background = 'transparent';

            textArea.value = sound_link;

            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            try {
                var successful = document.execCommand('copy');
                var msg = successful ? 'successful' : 'unsuccessful';
                console.log('Copying text command was ' + msg);
            } catch (err) {
                console.log('Oops, unable to copy');
            }

            document.body.removeChild(textArea);
        },
        tweet: function (path) {
            window.open('https://www.twitter.com/intent/tweet?url=' + encodeURIComponent('https://www.101soundboards.com' + path), '_blank');
        },
        addToFavorites: function (sound) {
            //Add to favorites
            console.log('addToFavorites', sound);
            console.log(sound);
            axios.put(`/api/v1/favorites/${sound.id}`)
                .then(function (response) {
                    console.log(response);
                    console.log('Showing toast...')

                    window.$toast.add({
                        severity: 'success',
                        summary: 'Added to favorites',
                        html: '<a class="btn btn btn-danger mt-1" href="/favorites/me">My Favorites</a>',
                        life: 10000
                    });
                })
                .catch(function (error) {
                    console.log(error);
                    console.log('Showing error toast...')

                    Swal.fire({
                        title: 'Problem',
                        text: 'There was a problem with your favorites. Please try again.',
                        icon: 'error',
                        confirmButtonText: 'OK',
                        theme: 'auto'
                    });
                });
        },
        report: function (sound) {
            //Report sound
            console.log('report', sound);
            console.log(sound);

            Swal.fire({
                title: 'Report Sound',
                html: 'Are you sure you want to report this sound?<br><br>You should only report sounds with offensive content, personal details, or if this was a Text-to-Speech phrase you created and would like to be removed.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Report',
                cancelButtonText: 'Cancel',
                theme: 'auto'
            }).then((result) => {
                if (!result.isConfirmed) {
                    return false;
                }

                axios.put(`/api/v1/sounds/${sound.id}/reports`)
                    .then(function (response) {
                        console.log(response);
                        console.log('Showing alert...')

                        Swal.fire({
                            title: 'Sound Reported',
                            text: 'Sound reported. Our moderators will review it shortly. If you reported a TTS phrase you created, it will be removed momentarily.',
                            icon: 'success',
                            buttons: {
                                OK: true
                            },
                            timer: 5000,
                            timerProgressBar: true,
                            theme: 'auto'
                        })
                    })
                    .catch(function (error) {
                        console.error(error);
                        console.log('Showing error alert...')
                        Swal.fire({
                            title: 'Error',
                            text: 'There was a problem reporting this sound. Please try again.',
                            icon: 'error',
                            confirmButtonText: 'OK',
                            timer: 5000,
                            timerProgressBar: true,
                            theme: 'auto'
                        });
                    });
            });
        },
    },
    created: function () {
        const errorMessage = document.getElementById("errorMessage");
        if (errorMessage) {
            errorMessage.style.display = "none";
        }
        // if (typeof window.sound_data_preload !== 'undefined') {
        //     this.load(window.sound_data_preload)
        // } else {
        //     this.load();
        // }

        //Listen for live updates
        // console.log('Subscribing to live updates');
        // this.echo.channel(`App.Models.Sound.${sound_id}`)
        //     .listen('.SoundUpdated', (e) => {
        //         console.log('Updated event received');
        //         console.log(e);

        //         //Use this new data
        //         this.load(e.model, false);
        //     })
        //     .listen('.SoundDeleted', (e) => {
        //         //Listen if sound was deleted and reload the page to show 404
        //         console.log('Sound was deleted. Reloading');
        //         window.location.reload(true);
        //         return true;
        //     });

        //Listen for everyone meep. A way to play a sound on all viewers' browsers at the same time
        //use App\Events\EveryoneMeep
        //EveryoneMeep::dispatch('/audio/coin.mp3');
        // console.log('Subscribing to everyone meep');
        // this.echo.channel('everyone-meep')
        //     .listen('EveryoneMeep', (e) => {
        //         console.log('Everyone meep event received');
        //         console.log(e);
        //         const audio = new Audio(e.audio_url);
        //         audio.volume = 0.4;
        //         audio.play();
        //     });

        //Listen for everyone refresh. A way to refresh all viewers' browsers at the same time for example on critical bug fix
        //use App\Events\EveryoneRefresh
        //EveryoneRefresh::dispatch();
        // console.log('Subscribing to everyone refresh');
        // this.echo.channel('everyone-refresh')
        //     .listen('EveryoneRefresh', (e) => {
        //         console.log('EveryoneRefresh event received');
        //         console.log(e);
        //         window.location.reload()
        //     });
    },
    mounted: function () {
        //Listen for volume change events
        window.addEventListener('volumeChange', (event) => {
            console.log('There was a volume change event (board.js)')
            console.log(event)
            console.log(event.volume)
            this.volume = event.volume
        })

        //Auto reload page every 60 minutes, to keep secure asset links fresh (they expire)
        //Also is a funny easter egg as the sound auto plays
        const reloadPageAfter = 60 * 60 * 1000;
        // setTimeout( () => {
        //     console.log('Refreshing page after ' + reloadPageAfter + ' delay')
        //     window.location.reload(true);
        // }, reloadPageAfter);
    }
})
    .component('sound-player', SoundPlayer)
    .component('transcript-suggestion', TranscriptSuggestion)
    .component('search', Search)
    .component('crosspromotion', Crosspromotion)
    .component('sound-downloader', SoundDownloader)
    .use(LazyComponent)
    .use(PrimeVue, {
        theme: {
            preset: PrimeVuePreset,
            options: {
                prefix: 'p',
                darkModeSelector: 'system',
                cssLayer: false
            }
        },
    })
    .use(ToastService)
    .mount('#vueApp');
